import { graphql } from 'relay-runtime';

export const timeLineMutation = graphql`
  mutation SkillResourceCreateTimelineEventMutation($input: InsertUserActionInput!) {
    insertUserAction(input: $input) {
      userActionNode {
        id
        description
        user {
          id
          publicUserId
          isActive
        }
        skill {
          id
          name
          code
        }
        lesson {
          id
          isActive
        }
      }
      errors {
        ... on Error {
          message
          __typename
        }
      }
    }
  }
`;

export const modalLessons = graphql`
  query SkillResourceGetLessonsQuery($input: LessonSkillsFilterInput!) {
    lessonSkills(filter: $input) {
      nodes {
        lesson {
          id
          name
          url
          summary
          spanishUrl
        }
      }
    }
  }
`;

export const getTimelineInfo = graphql`
  query SkillResourceGetTimelineQuery($filter: AllUserActionFilterInput!) {
    allUserActions(first: 100, filter: $filter, order: [{ timeStamp: ASC }]) {
      nodes {
        timeStamp
        actionType {
          id
          name
        }
        description
        lesson {
          id
          name
          summary
          url
          type {
            id
          }
        }
        skill {
          id
          name
          code
        }
        studentSkillAssessment {
          score
          sessionId
          activityId
        }
      }
    }
  }
`;

export const getSupportSkills = graphql`
  query SkillResourceGetSupportSkillsSkillStatesQuery($skillId: ID!, $studentId: ID!, $targetGroupId: ID!) {
    supportSkillsSkillStates(
      skillId: $skillId
      studentId: $studentId
      targetGroupId: $targetGroupId
      skillRelevanceIds: ["SkillRelevanceNode:2", "SkillRelevanceNode:3"]
    ) {
      skillRelevance {
        id
        name
      }
      studentSkill {
        id
        skillAssessment {
          score
        }
        skillSubstate {
          id
          name
        }
        readinessScore
        skill {
          id
          code
          name
          summary
        }
      }
    }
  }
`;

export const getSuccessorsSkills = graphql`
  query SkillResourceGetSuccessorsQuery($skillId: ID!, $studentId: ID!, $targetId: ID!) {
    successorSkillsSkillStates(
      skillId: $skillId
      skillRelevanceIds: ["SkillRelevanceNode:2", "SkillRelevanceNode:3"]
      studentId: $studentId
      targetGroupId: $targetId
    ) {
      id
      skillAssessment {
        score
      }
      skillSubstate {
        id
        name
      }
      readinessScore
      skill {
        id
        code
        name
        summary
      }
    }
  }
`;

export const getAssessmentStatus = graphql`
  mutation SkillResourceGetAssessmentStatusMutation($input: GetStudentLearnositySessionInput!) {
    getStudentLearnositySession(input: $input) {
      incompleteLearnositySessionNode {
        id
        activityId
        sessionId
        status
      }
    }
  }
`;
